<ng-container i18n *ngIf="requiresApproval">Request an account</ng-container>
<ng-container i18n *ngIf="!requiresApproval">Create an account</ng-container>
